/**
 * 외부회원(g5_out_members) 등록/수정 모달 — $j.F.Admin.OutMember.EditForm (정적 모듈)
 *
 * 외부회원관리(/adm/outer/members)와 매칭리스트 외부배차 탭이 동일한 편집 폼을 공유한다.
 * 차종/옵션/규격 드롭다운 데이터는 화면의 JSON 데이터 블록 #om-data 에서 읽는다.
 *   <script type="application/json" id="om-data">@json(OutMemberController::editFormData())</script>
 *   = { carTypes:[], carOptions:{차종:[]}, carMaster:{차종:[{code,label}]}, heightTypes:[] }
 *   → 두 페이지(outMember.blade / matchList.blade)가 싣는다.
 *
 * 사용법:
 *   // 신규 등록
 *   $j.F.Admin.OutMember.EditForm.open(null, { onSaved: () => reload() });
 *   // 행 데이터로 수정 (목록행에 pos_text/is_agree/memo/car_code 등 전 필드가 있을 때)
 *   $j.F.Admin.OutMember.EditForm.open(rowData, { onSaved: () => reload() });
 *   // 번호만 알 때 — /adm/ajax/outer/members/get 으로 조회 후 오픈
 *   $j.F.Admin.OutMember.EditForm.open(123, { onSaved: (params) => patch(params) });
 *
 * onSaved(params) — 저장 성공 시 호출. params 는 서버로 보낸 폼 값(editnum/name/phone/is_agree/sido…).
 */
import Util from '../../../Common/Util';
export default class OutMemberEditForm {
    static get MODAL_ID() { return 'jb-modal-outmember'; }

    /** #om-data(차종 마스터) — 없으면 빈 구조. 화면당 한 번 읽어 둔다 */
    static _data() {
        if (!this._cache) {
            const el = document.getElementById('om-data');
            this._cache = el ? JSON.parse(el.textContent) : null;
        }
        return this._cache || { carTypes: [], carOptions: {}, carMaster: {}, heightTypes: [] };
    }

    /**
     * 편집 모달 열기.
     * @param {null|number|string|object} arg  null=신규 / num=조회후오픈 / object=행데이터로 즉시오픈
     * @param {object} opts  { onSaved(params), title }
     */
    static open(arg, opts = {}) {
        this._opts = opts;
        if (arg === null || arg === undefined || arg === '') { this._render(null); return; }
        if (typeof arg === 'object') { this._render(arg); return; }

        // 번호만 받은 경우 — 전체 행 조회 후 오픈
        $.ajax({
            type: 'POST', url: '/adm/ajax/outer/members/get', data: { num: arg },
            success: (res) => {
                if (res && res.result === 'ok' && res.data) this._render(res.data);
                else $j.Ui.Dialog.open({ tone: 'danger', title: '조회 실패', desc: (res && res.message) || '외부회원을 찾을 수 없습니다.' });
            },
            error: () => $j.Ui.Dialog.open({ tone: 'danger', title: '오류', desc: '외부회원 조회 중 오류가 발생했습니다.' }),
        });
    }

    /* ───────────────────────── 렌더 ───────────────────────── */
    static _render(data) {
        const isNew = !data;
        const D = this._data();
        const carTypeOpts = (D.carTypes || []).map(t => `<option value="${t}">${t}</option>`).join('');

        const modalHtml = `<div class="om-modal">
            <input type="hidden" id="edit_num">
            <div class="omf-grid">
                <div class="omf-g">
                    <label>이름</label>
                    <input type="text" id="edit_name" class="omf-i">
                </div>
                <div class="omf-g">
                    <label>연락처</label>
                    <input type="text" id="edit_phone" class="omf-i" placeholder="010-0000-0000">
                    <span id="edit_phone_status" style="font-size:12px;margin-top:2px"></span>
                </div>
                <div class="omf-g">
                    <label>차종</label>
                    <select id="edit_car_type" class="omf-i">
                        <option value="">선택</option>
                        ${carTypeOpts}
                    </select>
                </div>
                <div class="omf-g">
                    <label>규격 <span class="omf-tags-hint" id="edit_car_code_hint">— 차종 선택 시</span></label>
                    <select id="edit_car_code" class="omf-i">
                        <option value="">선택</option>
                    </select>
                </div>
                <div class="omf-g">
                    <label>옵션 <span class="omf-tags-hint" id="edit_car_option_label_hint">— 차종을 먼저 선택하세요</span></label>
                    <div id="edit_car_option_tags" class="omf-tags"></div>
                    <input type="hidden" id="edit_car_option">
                </div>
                <div class="omf-g" id="edit_car_height_wrap">
                    <label>높이</label>
                    <input type="text" id="edit_car_height" class="omf-i">
                </div>
                <!-- 동의·카드결제는 항상 한 줄에 나란히 (높이 숨김 차종에서도 옵션 줄로 올라붙지 않도록 전용 행) -->
                <div class="omf-full omf-pair">
                    <div class="omf-g">
                        <label>동의여부</label>
                        <select id="edit_is_agree" class="omf-i">
                            <option value="0">미확인</option>
                            <option value="1">동의</option>
                            <option value="2">동의안함</option>
                        </select>
                    </div>
                    <div class="omf-g">
                        <label>카드결제</label>
                        <select id="edit_is_card" class="omf-i">
                            <option value="0">미확인</option>
                            <option value="1">가능</option>
                            <option value="2">불가능</option>
                        </select>
                    </div>
                </div>
                <div class="omf-g omf-full">
                    <label>지역 <span style="font-weight:400;color:var(--adm-c-909090, #909090)">— 지도에서 선택 (상세주소 제외 · 외부배차 거리계산용)</span></label>
                    <div style="display:flex;gap:6px;align-items:center">
                        <input type="text" id="edit_sido" class="omf-i" style="flex:1;background:var(--adm-b-f7f7f8, #f7f7f8)" placeholder="지도에서 선택하세요" readonly>
                        <button type="button" class="omf-btn" style="height:36px;padding:0 14px;background:#1D4ED8;color:#fff;flex-shrink:0" id="omf_map_btn">📍 지도에서 선택</button>
                    </div>
                    <input type="hidden" id="edit_pos">
                    <span id="edit_pos_status" style="font-size:12px;color:var(--adm-c-909090, #909090);margin-top:2px"></span>
                </div>
                <div class="omf-g omf-full">
                    <label>메모</label>
                    <textarea id="edit_memo" class="omf-i omf-ta" rows="8" maxlength="500" placeholder="관리 메모 (최대 500자)"></textarea>
                </div>
            </div>
            <div class="omf-foot">
                <button type="button" class="omf-btn omf-cancel" id="omf_cancel_btn">취소</button>
                <button type="button" class="omf-btn omf-save" id="omf_save_btn">저장</button>
            </div>
        </div>`;

        $j.Ui.JBModal.html(this.MODAL_ID, modalHtml, isNew ? '외부회원 등록' : '외부회원 수정');

        this._bind();
        this._prefill(data);
    }

    /* ───────────────────────── 이벤트 바인딩 ───────────────────────── */
    static _bind() {
        const Self = this;

        // 차종 변경 → 옵션 태그/규격 다시 그리기. 편집 진입(최초 1회)에는 저장된 옵션/규격을
        // data('initial-*') 로 1회 전달받아 선택상태로 그리고, 이후 사용자 변경에는 초기화한다.
        $('#edit_car_type').off('change.om').on('change.om', function () {
            const $sel = $(this);
            const carType = $sel.val();
            const initOpts = $sel.data('initial-opts');
            const opts = (initOpts !== undefined) ? initOpts : [];
            const initCode = $sel.data('initial-code');
            $sel.removeData('initial-opts').removeData('initial-code');
            Self._renderOptionTags(carType, opts);
            Self._renderCarCodeOptions(carType, (initCode !== undefined) ? initCode : '');
            // 높이(전고)는 해당 차종만 노출 (굴삭기 등은 숨기고 값 비움)
            const needHeight = (Self._data().heightTypes || []).indexOf(carType) !== -1;
            $('#edit_car_height_wrap').toggle(needHeight);
            if (!needHeight) $('#edit_car_height').val('');
            $('#edit_car_option_label_hint').toggle(!carType);
        });

        // 연락처 — 입력하는 대로 하이픈 자동 삽입 (저장값도 하이픈 포맷) + 번호를 다 치면 등록여부 판별
        $('#edit_phone').off('input.om').on('input.om', function () {
            this.value = Util.phoneNumber(this.value);
            Self._checkPhone();
        });
        $('#edit_phone').off('blur.om').on('blur.om', () => Self._checkPhone());

        $('#omf_map_btn').off('click.om').on('click.om', () => Self._openMap());
        $('#omf_save_btn').off('click.om').on('click.om', () => Self._doSave());
        $('#omf_cancel_btn').off('click.om').on('click.om', () => $j.Ui.JBModal.close(Self.MODAL_ID));

        // 옵션 태그 토글 — 모달 재오픈마다 핸들러 누적되지 않도록 document 위임 1회 바인딩
        if (!this._tagBound) {
            $(document).on('click', '#edit_car_option_tags .omf-tag', function () {
                $(this).toggleClass('on');
                Self._syncCarOptionInput();
            });
            this._tagBound = true;
        }
    }

    /* ───────────────────────── 값 채우기 ───────────────────────── */
    static _prefill(data) {
        if (!data) { $('#edit_car_type').val('').trigger('change.om'); return; }

        $('#edit_num').val(data.num);
        // 마스터에 없는 레거시 차종(예: 펌프카)도 select 값을 보존하기 위해 옵션을 동적 추가
        if (data.car_type && !$('#edit_car_type option[value="' + data.car_type + '"]').length) {
            $('#edit_car_type').append(`<option value="${data.car_type}">${data.car_type}</option>`);
        }
        $('#edit_name').val(data.name);
        $('#edit_phone').val(data.phone);
        $('#edit_sido').val(data.sido);
        $('#edit_car_height').val(data.car_height);
        $('#edit_is_agree').val(data.is_agree);
        $('#edit_is_card').val(data.is_card != null ? String(data.is_card) : '0');
        $('#edit_memo').val(data.memo);
        $('#edit_pos').val(data.pos_text || '');
        if (data.pos_text) $('#edit_pos_status').text('✓ 좌표 등록됨 (' + data.pos_text + ')').css('color', 'var(--adm-c-15803d, #15803D)');

        // 차종 값 세팅 + change 트리거 → 핸들러가 저장된 옵션·규격과 함께 렌더
        $('#edit_car_type')
            .data('initial-opts', this._parseOpts(data.car_option))
            .data('initial-code', (data.car_code != null ? String(data.car_code) : ''))
            .val(data.car_type || '')
            .trigger('change.om');
    }

    /**
     * 연락처 등록여부 판별 — 번호를 다 입력하면(8자리↑) 서버 조회 후 입력칸 아래에 결과 표시.
     * 저장 시 서버가 다시 막지만, 그 전에 이미 있는 회원인지 알려준다(수정 중이면 자기 자신은 제외).
     */
    static _checkPhone() {
        const $st  = $('#edit_phone_status');
        const raw  = ($('#edit_phone').val() || '');
        const norm = raw.replace(/[^0-9]/g, '');

        clearTimeout(this._phoneTimer);
        if (norm.length < 8) { $st.empty().removeAttr('style'); return; }

        this._phoneTimer = setTimeout(() => {
            $.ajax({
                type: 'POST', url: '/adm/ajax/outer/members/check-phone',
                data: { phone: norm, editnum: $('#edit_num').val() },
                success: (res) => {
                    // 응답 지연 중 번호가 바뀌었으면 버림 (뒤늦은 응답이 최신 입력을 덮지 않도록)
                    if (($('#edit_phone').val() || '').replace(/[^0-9]/g, '') !== norm) return;

                    if (!res || res.result !== 'ok' || !res.exists) { $st.empty().removeAttr('style'); return; }
                    $st.text('이미 등록된 번호입니다')
                        .css({ color: 'var(--adm-c-15803d, #15803D)', background: '#F0FDF4', border: '1px solid #BBF7D0', padding: '4px 8px', borderRadius: '4px' });
                },
            });
        }, G5['DEBOUNCE_TIME'] || 300);
    }

    /** 차종에 맞는 규격(car_code) 드롭다운. selectedCode 가 마스터에 없으면 임시 옵션으로 보존. */
    static _renderCarCodeOptions(carType, selectedCode) {
        const $sel = $('#edit_car_code');
        const D = this._data();
        const list = (D.carMaster && D.carMaster[carType]) ? D.carMaster[carType] : [];
        let html = '<option value="">선택</option>';
        list.forEach(c => { html += `<option value="${c.code}">${c.label}</option>`; });
        const sel = (selectedCode != null && selectedCode !== '') ? String(selectedCode) : '';
        // 마스터에 없는 레거시 코드도 값 보존
        if (sel && !list.some(c => String(c.code) === sel)) {
            html += `<option value="${sel}">코드 ${sel}</option>`;
        }
        $sel.html(html).val(sel);
        $('#edit_car_code_hint').toggle(!carType);
    }

    /** 콤마 구분 문자열 → 공백 제거된 옵션 배열 */
    static _parseOpts(str) {
        if (!str) return [];
        return String(str).split(',').map(s => s.trim()).filter(Boolean);
    }

    /** 차종에 맞는 옵션 태그. 마스터에 없지만 기존 데이터에 있던 값(legacy)은 점선 태그로 보존. */
    static _renderOptionTags(carType, selected) {
        const $box = $('#edit_car_option_tags');
        const D = this._data();
        const master = (D.carOptions && D.carOptions[carType]) ? D.carOptions[carType].slice() : [];
        const legacy = (selected || []).filter(v => v && master.indexOf(v) === -1);

        if (!carType) {
            $box.html('<span class="omf-tags-empty">차종을 선택하면 옵션이 표시됩니다</span>');
            $('#edit_car_option').val('');
            return;
        }
        if (!master.length && !legacy.length) {
            $box.html('<span class="omf-tags-empty">이 차종에는 선택 가능한 옵션이 없습니다</span>');
            $('#edit_car_option').val('');
            return;
        }
        const tags = master.map(v => this._tagHtml(v, selected.indexOf(v) !== -1, false))
            .concat(legacy.map(v => this._tagHtml(v, true, true)));
        $box.html(tags.join(''));
        this._syncCarOptionInput();
    }

    static _tagHtml(value, isOn, isLegacy) {
        const v = String(value).replace(/"/g, '&quot;');
        const cls = 'omf-tag' + (isOn ? ' on' : '') + (isLegacy ? ' legacy' : '');
        return `<span class="${cls}" data-v="${v}">${v}</span>`;
    }

    static _syncCarOptionInput() {
        const vals = $('#edit_car_option_tags .omf-tag.on').map(function () { return $(this).attr('data-v'); }).get();
        $('#edit_car_option').val(vals.join(','));
    }

    /* ───────────────────────── 지도(카카오 /adm/map 팝업) ───────────────────────── */
    static _openMap() {
        const pos = $('#edit_pos').val() || '';
        const addr = $('#edit_sido').val() || '';
        const url = '/adm/map?gps=' + encodeURIComponent(pos) + '&detail=0&addr=' + encodeURIComponent(addr);
        const w = 460, h = 760;
        const left = Math.max(0, (window.screen.width - w) / 2);
        const top = Math.max(0, (window.screen.height - h) / 2);
        const win = window.open(url, 'omMapPicker', `width=${w},height=${h},left=${left},top=${top},scrollbars=yes,resizable=yes`);
        if (!win) { $j.Ui.Dialog.open({ tone: 'warn', title: '팝업이 차단되었습니다', desc: '브라우저 팝업 허용 후 다시 시도하세요.' }); return; }
        win.focus();
        const Self = this;
        // /adm/map(searchMap) 은 적용 시 parent.callbackAddress(data) 호출 → 팝업에선 parent===자기자신이라 win 에 직접 정의
        win.callbackAddress = function (arr) {
            Self._applyAddress(arr);
            try { win.close(); } catch (e) { /* noop */ }
        };
    }

    static _applyAddress(arr) {
        // 지역 표기(시도+시군구+동/읍/면)는 서버가 만든다 — OutMemberController::save 의 Address::toSimple2.
        // 동기화(OutMemberSyncService)와 같은 함수라 두 경로의 저장값이 어긋나지 않는다.
        const region = arr.addr || '';
        $('#edit_sido').val(region);
        $('#edit_pos').val(arr.lat + ',' + arr.long);
        $('#edit_pos_status')
            .text('✓ 지도 선택됨 — ' + region + ' (' + (+arr.lat).toFixed(5) + ', ' + (+arr.long).toFixed(5) + ')')
            .css('color', 'var(--adm-c-15803d, #15803D)');
    }

    /* ───────────────────────── 저장 ───────────────────────── */
    static _doSave() {
        const phone = ($('#edit_phone').val() || '').trim();
        if (!phone) { $j.Ui.Dialog.open({ tone: 'warn', title: '연락처를 입력하세요.' }); return; }

        const params = {
            editnum:    $('#edit_num').val(),
            name:       $('#edit_name').val(),
            phone:      phone,
            car_type:   $('#edit_car_type').val(),
            car_code:   $('#edit_car_code').val(),
            car_option: $('#edit_car_option').val(),
            car_height: $('#edit_car_height').val(),
            sido:       $('#edit_sido').val(),
            is_agree:   $('#edit_is_agree').val(),
            is_card:    $('#edit_is_card').val(),
            memo:       $('#edit_memo').val(),
            pos:        $('#edit_pos').val(),
        };

        const onSaved = this._opts && this._opts.onSaved;
        // 호출측이 저장 후 자체 안내/리로드를 하면(skipSuccessToast) 기본 '저장완료' 토스트는 생략 — 토스트 중복 방지.
        const skipToast = this._opts && this._opts.skipSuccessToast;
        $('#omf_save_btn').prop('disabled', true);
        $.ajax({
            type: 'POST', url: '/adm/ajax/outer/members/save', data: params,
            success: (res) => {
                if (res.result === 'ok') {
                    $j.Ui.JBModal.close(this.MODAL_ID);
                    if (typeof onSaved === 'function') onSaved(params);
                    if (!skipToast) $j.Ui.Toast.show('저장완료', { type: 'success' });
                } else {
                    $('#omf_save_btn').prop('disabled', false);
                    $j.Ui.Dialog.open({ tone: 'danger', title: '저장 실패', desc: res.message || '' });
                }
            },
            error: () => {
                $('#omf_save_btn').prop('disabled', false);
                $j.Ui.Dialog.open({ tone: 'danger', title: '오류', desc: '저장 중 오류가 발생했습니다.' });
            },
        });
    }
}